import { render, staticRenderFns } from "./LoginIntro.vue?vue&type=template&id=836b901e&scoped=true&"
var script = {}
import style0 from "./LoginIntro.vue?vue&type=style&index=0&id=836b901e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836b901e",
  null
  
)

export default component.exports